import { Fragment, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useFormikContext } from 'formik'

import { useUk } from '../../../../hooks'
import { brToNewLine } from '../../../../utils/common'
import {
  FormBody,
  FormInlineNotifications,
  useFormValidationErrorsNotification,
} from '../../../Form'
import { FormikField, getFormikFormFieldErrorProps } from '../../../Formik'
import { Content } from '../../../Modal'
import { TabList } from '../../../Tab'
import Text from '../../../Text'
import { TextareaOutlineField } from '../../../Textarea'
import {
  USER_INVITATION_FORM_FIELD_NAME_MESSAGE,
  USER_INVITATION_FORM_FIELD_WITH_SMS,
  USER_INVITATION_FORM_TAB_NAME_EMAIL,
} from '../UserInvitationForm.constants'
import {
  getUserInvitationFormTabs,
  isUserInvitationFormEmailTab,
  isUserInvitationFormSmsTab,
} from '../UserInvitationForm.utils'
import { UserInvitationFormActions } from '../UserInvitationFormActions'
import { UserInvitationFormSubjectField } from '../UserInvitationFormSubjectField'

import * as styles from './UserInvitationFormFields.module.css'

function UserInvitationFormFields({
  Actions = UserInvitationFormActions,
  ContentComponent = Content,
  SubjectField = UserInvitationFormSubjectField,
  contentComponentProps,
  notifications,
  submitButtonText = 'Modal.SaveBtnKey',
  onCancel,
  onRemoveNotification,
  onSetNotification,
}) {
  const { t } = useTranslation()
  const { dirty, isSubmitting, values } = useFormikContext()

  useFormValidationErrorsNotification({
    onRemoveNotification,
    onSetNotification,
  })

  const ukData = useUk()
  const smsEnable = ukData.config.enable_sms_invitation
  const ukName = ukData.name
  const ukLang = ukData.language.code

  const smsText = brToNewLine(
    t('User.SmsInvitationTextKey', { lng: ukLang, ukName })
  )

  const [activeTab, setActiveTab] = useState(
    USER_INVITATION_FORM_TAB_NAME_EMAIL
  )

  function handleCancel() {
    onCancel({
      dirty,
    })
  }

  function getTabs(t) {
    return getUserInvitationFormTabs({
      smsTab: values[USER_INVITATION_FORM_FIELD_WITH_SMS],
      t,
    })
  }

  function handleOpenTab() {
    setActiveTab(USER_INVITATION_FORM_TAB_NAME_EMAIL)
  }

  return (
    <FormBody
      Actions={Actions}
      actionsProps={{
        ButtonAdd: null,
        ButtonClear: null,
        UploadComponent: null,
        cancelProps: {
          onClick: handleCancel,
        },
        className: styles.actions,
        smsEnable,
        submitProps: {
          isLoading: isSubmitting,
          title: submitButtonText,
        },
        onOpenInitTab: handleOpenTab,
      }}
    >
      <ContentComponent {...contentComponentProps}>
        <FormInlineNotifications notifications={notifications} />

        <TabList
          activeTab={activeTab}
          getTabs={getTabs}
          onSetActiveTab={setActiveTab}
        />
        {isUserInvitationFormEmailTab(activeTab) ? (
          <>
            {SubjectField ? <SubjectField /> : null}
            <FormikField
              clearable
              Component={TextareaOutlineField}
              Field={Fragment}
              className={styles.textarea}
              getErrorProps={getFormikFormFieldErrorProps}
              maxLength={ukData.config.invite_max_length}
              name={USER_INVITATION_FORM_FIELD_NAME_MESSAGE}
              placeholder={t('User.EmailTextPlaceholderKey')}
            />
          </>
        ) : null}
        {isUserInvitationFormSmsTab(activeTab) ? (
          <Text className={styles.text}>{smsText}</Text>
        ) : null}
      </ContentComponent>
    </FormBody>
  )
}

export default UserInvitationFormFields
